import React, { useEffect, useState } from 'react';
import ImageUpload from '../ImageUpload/ImageUpload.js';
import ConfirmationDialog from '../ConfirmationDialog.js';
import { useDispatch, useSelector } from 'react-redux';
import {
  editPartners,
  resetSelectedPartnersRow,
  clearData,
  addPartners,
} from '../../../Redux/partnersRedux.js';

const AddPartners = ({ setShowForm }) => {
  const { selectedPartnersRow } = useSelector((state) => state.partnersRedux);
  const [uploadedImages, setUploadedImages] = useState([]);
  const [clearImages, setClearImages] = useState(false);
  const dispatch = useDispatch();
  const [isEditing, setIsEditing] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [partnerData, setPartnerData] = useState({
    partnerName: '',
    description: '',
    location: '',
    urlLink: '',
  });

  const user = JSON.parse(localStorage.getItem('user'));

  useEffect(() => {
    if (selectedPartnersRow && Object.keys(selectedPartnersRow).length > 0) {
      setUploadedImages(
        Array.isArray(selectedPartnersRow.images)
          ? selectedPartnersRow.images
          : []
      );
      setPartnerData({
        partnerName: selectedPartnersRow.partnerName || '',
        description: selectedPartnersRow.description || '',
        location: selectedPartnersRow.location || '',
        urlLink: selectedPartnersRow.urlLink || '',
      });
      setIsEditing(true);
    } else {
      resetForm();
    }
  }, [selectedPartnersRow]);

  const handleImageChange = (images) => {
    const img = images.map((imageObj) => ({ image: imageObj.image }));
    setUploadedImages(img);
  };

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setPartnerData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const editPartnerConfirm = () => {
    const slideId = selectedPartnersRow.id;
    const adminId = user.userId;
    const updatedPartner = {
      images: uploadedImages,
      partnerName: partnerData.partnerName,
      description: partnerData.description,
      location: partnerData.location,
      urlLink: partnerData.urlLink,
    };
    dispatch(editPartners(adminId, updatedPartner, slideId))
      .then(() => {
        resetForm();
        setShowForm(false);
        setClearImages(true);
        dispatch(clearData());
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  };

  const handleClose = () => {
    resetForm();
    setShowForm(false);
    setConfirmDialog(false);
    dispatch(resetSelectedPartnersRow());
  };
  const handleConfirmClose = () => {
    setConfirmDialog(false);
  };

  const handlePartnerSubmit = (e) => {
    e.preventDefault();
    const newPartner = {
      images: uploadedImages,
      partnerName: partnerData.partnerName,
      description: partnerData.description,
      location: partnerData.location,
      urlLink: partnerData.urlLink,
    };
    const adminId = user.userId;
    if (isEditing) {
      setConfirmDialog(true);
    } else {
      dispatch(addPartners(adminId, newPartner))
        .then(() => {
          resetForm();
          setShowForm(false);
          setUploadedImages([]);
          setClearImages(true);
        })
        .catch((error) => {
          console.error('Error in adding partner:', error);
        });
    }
  };

  const resetForm = () => {
    setPartnerData({
      partnerName: '',
      description: '',
      location: '',
      urlLink: '',
    });
    setIsEditing(false);
  };

  return (
    <>
      <div className='m-3'>
        <h5>{isEditing ? 'Edit Home Slide' : 'Add Home Slide'}</h5>
        <div style={{ padding: '25px' }}>
          <form>
            <div className='row'>
              <div className='col-12'>
                <label htmlFor='Image'>
                  Image<span style={{ color: 'red' }}>*</span>
                </label>
                <ImageUpload
                  onImagesChange={handleImageChange}
                  clearImages={clearImages}
                  isEditing={isEditing}
                  allowMultiple={false}
                  currentImages={selectedPartnersRow?.images}
                />
              </div>
            </div>
            <div className='row mt-3'>
              <div className='col-12'>
                <label htmlFor='partnerName'>Name</label>
                <input
                  type='text'
                  value={partnerData.partnerName}
                  onChange={handleChange}
                  id='partnerName'
                  name='partnerName'
                  className='form-control mb-3'
                  style={{ border: '1px solid #cccccc' }}
                  required
                />
              </div>
            </div>
            <div className='row'>
              <div className='col-12'>
                <label htmlFor='description'>Description</label>
                <div className='form-floating'>
                  <textarea
                    required
                    className='form-control mb-3'
                    id='description'
                    name='description'
                    value={partnerData.description}
                    onChange={handleChange}
                    style={{ height: '100px' }}
                  ></textarea>
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-6'>
                <label htmlFor='location'>Location</label>
                <input
                  type='text'
                  required
                  className='form-control mb-3'
                  id='location'
                  name='location'
                  value={partnerData.location}
                  onChange={handleChange}
                ></input>
              </div>
              <div className='col-6'>
                <label htmlFor='urlLink'>URL Link</label>
                <input
                  type='text'
                  required
                  className='form-control mb-3'
                  id='urlLink'
                  name='urlLink'
                  value={partnerData.urlLink}
                  onChange={handleChange}
                ></input>
              </div>
            </div>
            <div className='row'>
              <div className='d-grid gap-2 col-6 mx-auto'>
                <button
                  className='btn'
                  style={{ background: '#2b6930', color: '#fff' }}
                  onClick={handlePartnerSubmit}
                >
                  Submit
                </button>
              </div>
              <div className='d-grid gap-2 col-6 mx-auto'>
                <button
                  className='btn'
                  style={{ background: '#C0000B', color: '#fff' }}
                  onClick={handleClose}
                >
                  Cancel
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <ConfirmationDialog
        open={confirmDialog}
        onClose={handleConfirmClose}
        onConfirm={editPartnerConfirm}
        description='Are you sure you want to save?'
      />
    </>
  );
};

export default AddPartners;
